// translations.js
export const translations = {
    en: {
    shipments: 'Sales for the current month',
    top5SKU: 'Sales growth in money: current month vs previous',
    top5DistributorsMonth: 'Sales dynamics by days in money for the current month',
    shipmentsDSArmenia: 'Distributors’ sales for the current month',
    shipmentsKazakhstan: 'Top 10 distributors in money for the current month',
    zeroShipments: 'Top 10 products in pieces for the current month',
    salesByBrands: 'Top-10 sales agents by distributors in money for the current month',
  },
  ru: {
    shipments: 'Продажи за текущий месяц',
    top5SKU: 'Прирост продаж в деньгах: текущий месяц vs предыдущий ',
    top5DistributorsMonth: 'Динамика продаж по дням в деньгах за текущий месяц',
    shipmentsDSArmenia: 'Продажи дистрибьюторов за текущий месяц',
    shipmentsKazakhstan: 'ТОП-10 дистрибьюторов в деньгах за текущий месяц',
    zeroShipments: 'ТОП-10 продуктов в штуках за текущий месяц',
    salesByBrands: 'ТОП-10 торговых агентов по дистрибьюторам в деньгах за текущий месяц',
  },
  uk: {
    shipments: 'Продажі за поточний місяць',
    top5SKU: 'Приріст продажів у грошах: поточний місяць vs попередній',
    top5DistributorsMonth: 'Динаміка продажів по днях у грошах за поточний місяць',
    shipmentsDSArmenia: 'Продажі дистриб’юторів за поточний місяць',
    shipmentsKazakhstan: 'ТОП-10 дистриб’юторів у грошах за поточний місяць',
    zeroShipments: 'ТОП-10 продуктів у штуках за поточний місяць',
    salesByBrands: 'ТОП-10 торгових агентів по дистриб’юторах у грошах за поточний місяць',
  },
};
